export const DASHBOARD = {
  NUMBER_PER_PAGE: 10,
  FILTER: {
    FROM_DATE: 'from',
    TO_DATE: 'to',
    ANALYST: 'analyst',
    TITLE: 'title',
  },
};

export const CONFERENCE = {
  MAX_TITLE_LENGTH: 255,
};

export const MULTI_FACTOR_AUTH_ATTEMPTS_FAILED_LIMIT = 2;

export const MIN_CONFERENCE_DURATION =
  parseInt(process.env.MIN_CONFERENCE_DURATION, 10) || 300;



// WEBPACK FOOTER //
// ./config/modelsConfig.js